/* eslint-disable no-param-reassign */

import React, { FunctionComponent, useMemo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Alert from 'Shared/components/Alert'
import { useForm, Controller, FieldValues } from 'react-hook-form'
import { ReviewSelectValue } from 'Types/index'
import { SelectPlaylist } from '../SelectPlaylist'

import { WarningFormProps, WarningFormValues } from './props'
import {
  Content,
  AlertText,
  AlertTitle,
  TextRow,
  FormContainer,
  SelectLabel,
  ButtonsContainer,
  Button,
  ButtonGrey,
} from './styles'

export const WarningForm: FunctionComponent<WarningFormProps> = ({
  setPlaylistFromWarning,
  setThreeReviewsWarning,
  setModalHeaderGreen,
}) => {
  const { t } = useTranslation()

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<FieldValues>({
    mode: 'onChange',
  })

  const watchSelect: ReviewSelectValue = watch('reviewPlaylistSelect')
  const onClose = () => {
    setThreeReviewsWarning(false)
    setModalHeaderGreen(true)
  }

  const onSubmit = (values: WarningFormValues) => {
    setPlaylistFromWarning(values.reviewPlaylistSelect)
    onClose()
  }

  return (
    <Content>
      <Alert color="warning" icon unclosable rowDirection noGap>
        <AlertText>
          <AlertTitle>{t('reviewsPage.threeReviewsWarningTitle')}</AlertTitle>
        </AlertText>
      </Alert>
      <TextRow>{t('reviewsPage.threeReviewsWarningRow1')}</TextRow>
      <TextRow>{t('reviewsPage.threeReviewsWarningRow2')}</TextRow>
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <SelectLabel>{t('reviewsPage.selectLabel')}</SelectLabel>
        <Controller
          control={control}
          name="reviewPlaylistSelect"
          render={({ field: { onChange, value, ref } }) => (
            <SelectPlaylist
              noReject
              ref={ref}
              value={value}
              onChange={onChange}
            />
          )}
        />
        <ButtonsContainer>
          <ButtonGrey onClick={onClose}>
            {t('reviewsPage.continueWithoutAdding')}
          </ButtonGrey>
          <Button type="submit" disabled={!watchSelect}>
            {t('reviewsPage.addToPlaylist')}
          </Button>
        </ButtonsContainer>
      </FormContainer>
    </Content>
  )
}
